import { api } from '../utils/api';
import type { Order, OrderDestination } from '../types/@types/order';
import type { CreateTakeawayOrderPayload } from '../services/OrderService';

export interface TakeawayOrderPayload extends CreateTakeawayOrderPayload { }

export interface GetOrdersOptions {
  destination?: OrderDestination;
  q?: string;
  page?: number;
  paid?: boolean;
}

export interface TakeawayOrderFilters {
  status?: string;
  paid?: boolean;
  from?: string;
  to?: string;
}

export interface TakeawayOrderTotals {
  subtotal?: number | null;
  total?: number | null;
}

export interface TakeawayOrderDetail extends Order {
  products?: Order['items'];
  totals?: TakeawayOrderTotals | null;
}

export type ChargeTakeawayOrderPayload = {
  method: string;
  amount: number;
  tip?: number;
  received?: number;
  reference?: string;
  closeOrder?: boolean;
  /** ID de la caja activa. Obligatorio en entornos multi-caja. */
  cashRegisterId?: number | string;
};

export async function createTakeawayOrder(payload: TakeawayOrderPayload) {
  const body = {
    ...payload,
    destination: 'TAKEAWAY' as const,
  };

  const { data } = await api.post('/orders/takeaway', body);
  return data as Order;
}

export async function getOrders(options?: GetOrdersOptions) {
  const params = options && Object.keys(options).length > 0 ? options : undefined;
  const { data } = await api.get('/orders', { params });
  return data as Order[];
}

export async function fetchTakeawayOrders(filters?: TakeawayOrderFilters) {
  const params = filters && Object.keys(filters).length > 0 ? filters : undefined;
  const { data } = await api.get('/orders/takeaway', { params });
  return data as TakeawayOrderDetail[];
}

export async function fetchTakeawayOrder(id: string | number) {
  if (!id) {
    throw new Error('Invalid order id');
  }
  const { data } = await api.get(`/orders/takeaway/${id}`);
  return data as TakeawayOrderDetail;
}

export async function chargeTakeawayOrder(id: string | number, payload: ChargeTakeawayOrderPayload) {
  if (!id) {
    throw new Error('Invalid order id');
  }
  const { data } = await api.patch(`/orders/takeaway/${id}/charge`, payload);
  return data as Order;
}

export async function getTakeawayOrders(params?: { paid?: boolean }) {
  const paid = params?.paid ?? false;
  const orders = await fetchTakeawayOrders({ paid });
  return orders as Order[];
}

export async function payOrder(id: string | number) {
  if (!id) {
    throw new Error('Invalid order id');
  }
  const { data } = await api.patch(`/orders/${id}/pay`);
  return data as Order;
}

export async function getOrderById(id: string | number) {
  if (!id) {
    throw new Error('Invalid order id');
  }
  const { data } = await api.get(`/orders/${id}`);
  return data as Order;
}
